const sectionCode = "SPRO2";
const chartCode = "C031x";

import { Procedures } from "modules/provider/shared/procedure-charts";

function T31Procedures() {
  return <Procedures chartCode={chartCode} sectionCode={sectionCode} />;
}

export { T31Procedures };
